import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff50fdd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sa-wrapper" }
const _hoisted_2 = { class: "sa-header" }
const _hoisted_3 = { class: "sa-title" }
const _hoisted_4 = { class: "sa-subtitle" }
const _hoisted_5 = {
  key: 0,
  class: "sa-error"
}
const _hoisted_6 = { class: "sa-form-grid" }
const _hoisted_7 = { class: "sa-card" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sa-section-title" }, "Kurs-Metadaten", -1))
const _hoisted_9 = {
  key: 0,
  class: "form-group"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Kurs-ID "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-hint" }, "Einmal vergeben, nicht änderbar. Nur Kleinbuchstaben und Bindestriche.", -1))
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Titel "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Beschreibung", -1))
const _hoisted_16 = { class: "form-row" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Kategorie", -1))
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dauer (Minuten)", -1))
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Vorschaubild", -1))
const _hoisted_23 = { class: "image-upload" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "image-upload-actions" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 1,
  class: "image-upload-error"
}
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "checkbox-label" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Veröffentlicht (sichtbar für Organisationen)", -1))
const _hoisted_31 = { class: "sa-right-col" }
const _hoisted_32 = { class: "sa-card" }
const _hoisted_33 = { class: "sa-section-header" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sa-section-title" }, "Lektionen", -1))
const _hoisted_35 = { class: "sa-section-header-actions" }
const _hoisted_36 = {
  key: 2,
  class: "form-hint"
}
const _hoisted_37 = {
  key: 0,
  class: "form-hint",
  style: {"padding":"12px 0"}
}
const _hoisted_38 = {
  key: 1,
  class: "lesson-empty"
}
const _hoisted_39 = {
  class: "lesson-row__main",
  title: "Zum Sortieren ziehen"
}
const _hoisted_40 = { class: "lesson-order" }
const _hoisted_41 = { class: "lesson-headline" }
const _hoisted_42 = { class: "lesson-title" }
const _hoisted_43 = {
  key: 0,
  class: "lesson-desc"
}
const _hoisted_44 = {
  key: 0,
  class: "lesson-status lesson-status--none"
}
const _hoisted_45 = {
  key: 1,
  class: "lesson-status lesson-status--live"
}
const _hoisted_46 = ["aria-expanded", "onClick"]
const _hoisted_47 = {
  key: 0,
  class: "lesson-menu-list",
  role: "menu"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lesson-menu-sep" }, null, -1))
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 0,
  class: "lesson-draft"
}
const _hoisted_55 = { class: "lesson-draft__actions" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["disabled", "onClick"]
const _hoisted_58 = ["disabled", "onClick"]
const _hoisted_59 = { class: "sa-card" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sa-section-title" }, "Org-Sichtbarkeit", -1))
const _hoisted_61 = {
  key: 0,
  class: "vis-all-badge"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "vis-all-label" }, "Für alle Organisationen sichtbar", -1))
const _hoisted_63 = {
  key: 0,
  class: "vis-chips"
}
const _hoisted_64 = ["onClick", "title"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chip-x" }, "×", -1))
const _hoisted_66 = {
  key: 1,
  class: "form-hint",
  style: {"margin-bottom":"10px"}
}
const _hoisted_67 = { class: "vis-actions-row" }
const _hoisted_68 = { class: "lesson-modal" }
const _hoisted_69 = { class: "org-picker-header" }
const _hoisted_70 = { class: "org-picker-title" }
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Titel "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_73 = { class: "form-group" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Beschreibung", -1))
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = { class: "label-with-info" }
const _hoisted_77 = ["aria-expanded"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-hint" }, [
  /*#__PURE__*/_createTextVNode(" Empfehlung: "),
  /*#__PURE__*/_createElementVNode("strong", null, "SCORM 2004"),
  /*#__PURE__*/_createTextVNode(" – besseres Tracking einzelner Module als 1.2. ")
], -1))
const _hoisted_79 = {
  key: 0,
  class: "info-bubble"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "SCORM 2004", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "progress_measure", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "SCORM 1.2", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "2004", -1))
const _hoisted_84 = {
  key: 0,
  class: "upload-draft-hint"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Entwurf", -1))
const _hoisted_86 = { class: "file-drop" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-drop-icon" }, "📦", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-drop-hint" }, "ZIP auswählen oder hier ablegen", -1))
const _hoisted_90 = {
  key: 2,
  class: "upload-status-card"
}
const _hoisted_91 = { class: "upload-status-filename" }
const _hoisted_92 = { class: "upload-progress-wrap" }
const _hoisted_93 = {
  key: 1,
  class: "upload-progress-bar upload-progress-bar--indeterminate"
}
const _hoisted_94 = { class: "upload-phase-label" }
const _hoisted_95 = {
  key: 3,
  class: "upload-status-card upload-status-card--success"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "upload-status-icon" }, "✓", -1))
const _hoisted_97 = {
  key: 4,
  class: "upload-status-card upload-status-card--error"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "upload-status-icon" }, "✕", -1))
const _hoisted_99 = {
  key: 0,
  class: "upload-error"
}
const _hoisted_100 = { class: "sa-modal-actions" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = { class: "lesson-modal" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin":"0 0 12px","font-size":"1.05rem"} }, "Lektion löschen?", -1))
const _hoisted_104 = { style: {"color":"#60666c","font-size":"0.9rem","margin":"0 0 20px"} }
const _hoisted_105 = { class: "sa-modal-actions" }
const _hoisted_106 = ["disabled"]
const _hoisted_107 = { class: "org-picker-modal" }
const _hoisted_108 = { class: "org-picker-header" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "org-picker-title" }, "Organisationen auswählen", -1))
const _hoisted_110 = {
  key: 0,
  class: "org-picker-empty"
}
const _hoisted_111 = {
  key: 1,
  class: "org-picker-list"
}
const _hoisted_112 = ["checked", "onChange"]
const _hoisted_113 = { class: "org-picker-name" }
const _hoisted_114 = { class: "org-picker-id" }
const _hoisted_115 = {
  key: 0,
  class: "org-picker-empty"
}
const _hoisted_116 = { class: "org-picker-footer" }
const _hoisted_117 = { class: "sa-form-footer" }
const _hoisted_118 = {
  key: 0,
  class: "sa-error"
}
const _hoisted_119 = {
  key: 1,
  class: "sa-success"
}
const _hoisted_120 = { class: "sa-form-actions" }
const _hoisted_121 = ["disabled"]
const _hoisted_122 = {
  key: 0,
  class: "scorm-preview-overlay"
}
const _hoisted_123 = { class: "scorm-preview-bar" }
const _hoisted_124 = { class: "scorm-preview-bar-left" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "scorm-preview-badge" }, "Vorschau", -1))
const _hoisted_126 = { class: "scorm-preview-title" }
const _hoisted_127 = {
  key: 0,
  class: "scorm-preview-draft-tag"
}
const _hoisted_128 = { class: "scorm-preview-bar-right" }
const _hoisted_129 = ["title"]
const _hoisted_130 = {
  key: 0,
  class: "scorm-preview-error"
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scorm-preview-error-icon" }, "⚠", -1))
const _hoisted_132 = { class: "scorm-preview-error-body" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Inhalt nicht erreichbar", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "scorm-preview-error-hint" }, [
  /*#__PURE__*/_createTextVNode(" Mögliche Ursachen:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" • Der S3-Bucket ist nicht öffentlich erreichbar (cloudformation.yml: "),
  /*#__PURE__*/_createElementVNode("em", null, "S3CourseContentBucketPolicy"),
  /*#__PURE__*/_createTextVNode(")"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" • Die Extraktion schlug fehl (CloudWatch Logs: "),
  /*#__PURE__*/_createElementVNode("em", null, "ExtractScorm"),
  /*#__PURE__*/_createTextVNode(") ")
], -1))
const _hoisted_136 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.isEdit ? 'Kurs bearbeiten' : 'Neuer Kurs'), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.isEdit ? _ctx.form.courseId : 'SCORM-Paket auf S3 und Metadaten pflegen'), 1)
        ]),
        _createVNode(_component_router_link, {
          to: "/superadmin/courses",
          class: "btn btn-secondary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" ← Zurück zur Übersicht ")
          ]),
          _: 1
        })
      ]),
      (_ctx.loadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.loadError), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (!_ctx.isEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.courseId) = $event)),
                  type: "text",
                  placeholder: "z.B. harnkontinenz-pflege",
                  class: "form-input"
                }, null, 512), [
                  [_vModelText, _ctx.form.courseId]
                ]),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.title) = $event)),
              type: "text",
              placeholder: "Kursname",
              class: "form-input"
            }, null, 512), [
              [_vModelText, _ctx.form.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.description) = $event)),
              rows: "3",
              class: "form-input",
              placeholder: "Kurze Kursbeschreibung …"
            }, null, 512), [
              [_vModelText, _ctx.form.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.category) = $event)),
                type: "text",
                placeholder: "z.B. Pflege & Gesundheit",
                class: "form-input"
              }, null, 512), [
                [_vModelText, _ctx.form.category]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.durationMinutes) = $event)),
                type: "number",
                min: "0",
                class: "form-input"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.durationMinutes,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              (_ctx.form.imageUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.form.imageUrl,
                    alt: "Vorschau",
                    class: "image-preview"
                  }, null, 8, _hoisted_24))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("input", {
                  ref: "imageInput",
                  type: "file",
                  accept: "image/*",
                  class: "hidden-file",
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onImageSelected && _ctx.onImageSelected(...args)))
                }, null, 544),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  disabled: _ctx.imageUploadLoading,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.triggerImageUpload && _ctx.triggerImageUpload(...args)))
                }, _toDisplayString(_ctx.imageUploadLoading ? `Lädt … ${_ctx.imageUploadProgress}%` : (_ctx.form.imageUrl ? 'Bild ersetzen' : 'Bild hochladen')), 9, _hoisted_26),
                (_ctx.form.imageUrl && !_ctx.imageUploadLoading)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn-link",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.imageUrl = ''))
                    }, " Entfernen "))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.imageUrl) = $event)),
                type: "url",
                placeholder: "oder Bild-URL einfügen (https://…)",
                class: "form-input"
              }, null, 512), [
                [_vModelText, _ctx.form.imageUrl]
              ]),
              (_ctx.imageUploadError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.imageUploadError), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("label", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.published) = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.published]
              ]),
              _hoisted_30
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                (_ctx.isEdit && _ctx.lessons.some(l => !!l.s3Key))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-link",
                      style: {"font-size":"0.8125rem"},
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.previewCourse && _ctx.previewCourse(...args)))
                    }, "Vorschau ↗"))
                  : _createCommentVNode("", true),
                (_ctx.isEdit)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-secondary btn-sm",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openAddLesson && _ctx.openAddLesson(...args)))
                    }, " + Lektion "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_36, "Kurs erst speichern."))
              ])
            ]),
            (_ctx.lessonsLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Wird geladen …"))
              : (_ctx.lessons.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Noch keine Lektionen vorhanden. "))
                : (_openBlock(), _createBlock(_component_draggable, {
                    key: 2,
                    modelValue: _ctx.lessons,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.lessons) = $event)),
                    "item-key": "lessonId",
                    class: "lesson-list",
                    animation: 160,
                    "ghost-class": "lesson-row--ghost",
                    "drag-class": "lesson-row--drag",
                    filter: "button, a",
                    "prevent-on-filter": false,
                    "force-fallback": true,
                    "fallback-tolerance": 4,
                    onEnd: _ctx.onLessonReorder
                  }, {
                    item: _withCtx(({ element: lesson, index: idx }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["lesson-row", { 'has-draft': !!lesson.draftKey }])
                      }, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(idx + 1), 1),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("span", _hoisted_42, _toDisplayString(lesson.title), 1),
                            (lesson.description)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(lesson.description), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (!lesson.s3Key)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Kein Inhalt"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_45, "Live")),
                          _createElementVNode("div", {
                            class: "lesson-menu",
                            onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("button", {
                              class: "lesson-menu-btn",
                              type: "button",
                              title: "Aktionen",
                              "aria-haspopup": "true",
                              "aria-expanded": _ctx.openMenuId === lesson.lessonId,
                              onClick: ($event: any) => (_ctx.toggleMenu(lesson.lessonId))
                            }, "⋯", 8, _hoisted_46),
                            (_ctx.openMenuId === lesson.lessonId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  (lesson.s3Key)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "lesson-menu-item",
                                        role: "menuitem",
                                        onClick: ($event: any) => {_ctx.previewLesson(lesson); _ctx.closeMenu()}
                                      }, "Vorschau ↗", 8, _hoisted_48))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    class: "lesson-menu-item",
                                    role: "menuitem",
                                    onClick: ($event: any) => {_ctx.openEditLesson(lesson); _ctx.closeMenu()}
                                  }, "Bearbeiten", 8, _hoisted_49),
                                  (!lesson.s3Key)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "lesson-menu-item",
                                        role: "menuitem",
                                        onClick: ($event: any) => {_ctx.openEditLesson(lesson); _ctx.closeMenu()}
                                      }, "SCORM hochladen", 8, _hoisted_50))
                                    : _createCommentVNode("", true),
                                  (lesson.s3Key)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        class: "lesson-menu-item",
                                        role: "menuitem",
                                        onClick: ($event: any) => {_ctx.openNewVersionUpload(lesson); _ctx.closeMenu()}
                                      }, "Neue Version hochladen", 8, _hoisted_51))
                                    : _createCommentVNode("", true),
                                  _hoisted_52,
                                  _createElementVNode("button", {
                                    class: "lesson-menu-item lesson-menu-item--danger",
                                    role: "menuitem",
                                    onClick: ($event: any) => {_ctx.confirmDeleteLesson(lesson); _ctx.closeMenu()}
                                  }, "Löschen", 8, _hoisted_53)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (lesson.draftKey)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("button", {
                                  class: "btn-link",
                                  onClick: ($event: any) => (_ctx.previewDraft(lesson))
                                }, "Entwurf ↗", 8, _hoisted_56),
                                _createElementVNode("button", {
                                  class: "btn-link btn-publish",
                                  disabled: _ctx.publishingDraft === lesson.lessonId,
                                  onClick: ($event: any) => (_ctx.publishDraft(lesson))
                                }, "✓ " + _toDisplayString(_ctx.publishingDraft === lesson.lessonId ? '…' : 'Veröffentlichen'), 9, _hoisted_57),
                                _createElementVNode("button", {
                                  class: "btn-link btn-danger",
                                  disabled: _ctx.discardingDraft === lesson.lessonId,
                                  onClick: ($event: any) => (_ctx.discardDraft(lesson))
                                }, "✕ " + _toDisplayString(_ctx.discardingDraft === lesson.lessonId ? '…' : 'Verwerfen'), 9, _hoisted_58)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onEnd"]))
          ]),
          _createElementVNode("div", _hoisted_59, [
            _hoisted_60,
            (_ctx.visForAll)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _hoisted_62,
                  _createElementVNode("button", {
                    class: "btn-link",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.visForAll = false))
                  }, "Einschränken")
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.selectedOrgs.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOrgs, (org) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: org.organisationId,
                            class: "vis-chip",
                            onClick: ($event: any) => (_ctx.removeOrg(org.organisationId)),
                            title: org.organisationId
                          }, [
                            _createTextVNode(_toDisplayString(org.name), 1),
                            _hoisted_65
                          ], 8, _hoisted_64))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_66, " Noch keine Organisation ausgewählt. ")),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary btn-sm",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.openOrgPicker && _ctx.openOrgPicker(...args)))
                    }, " Organisationen auswählen "),
                    _createElementVNode("button", {
                      class: "btn-link",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.visForAll = true))
                    }, " Für alle freigeben ")
                  ])
                ], 64))
          ]),
          (_ctx.lessonModalVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "modal-backdrop",
                onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.lessonModalVisible = false), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.lessonModalMode === 'create' ? 'Lektion hinzufügen' : 'Lektion bearbeiten'), 1),
                    _createElementVNode("button", {
                      class: "btn-close",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.lessonModalVisible = false))
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.lessonForm.title) = $event)),
                      type: "text",
                      class: "form-input",
                      placeholder: "Lektionsname"
                    }, null, 512), [
                      [_vModelText, _ctx.lessonForm.title]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.lessonForm.description) = $event)),
                      rows: "2",
                      class: "form-input",
                      placeholder: "Kurze Beschreibung …"
                    }, null, 512), [
                      [_vModelText, _ctx.lessonForm.description]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("label", _hoisted_76, [
                      _createTextVNode(" SCORM-Paket (ZIP) "),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["info-btn", { 'is-open': _ctx.scormInfoOpen }]),
                        "aria-haspopup": "true",
                        "aria-expanded": _ctx.scormInfoOpen,
                        "aria-label": "Hinweis zu SCORM-Versionen",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.scormInfoOpen = !_ctx.scormInfoOpen))
                      }, "i", 10, _hoisted_77)
                    ]),
                    _hoisted_78,
                    (_ctx.scormInfoOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _hoisted_80,
                          _createTextVNode(" meldet den Fortschritt je Modul ("),
                          _hoisted_81,
                          _createTextVNode(") und ermöglicht so einen genauen Zwischenstand und eine Lernzeit. "),
                          _hoisted_82,
                          _createTextVNode(" kann das nicht – dort ist nur „begonnen / abgeschlossen\" verlässlich. Exportieren Sie das Paket daher möglichst als Version "),
                          _hoisted_83,
                          _createTextVNode(". ")
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.lessonUploadStatus === 'idle')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.lessonIsVersionUpdate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                _createTextVNode(" Der Upload erstellt einen "),
                                _hoisted_85,
                                _createTextVNode(" — die Live-Version bleibt unverändert. ")
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("label", _hoisted_86, [
                            _createElementVNode("input", {
                              type: "file",
                              accept: ".zip,application/zip,application/x-zip-compressed",
                              disabled: _ctx.lessonUploadLoading,
                              onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onLessonFileSelected && _ctx.onLessonFileSelected(...args)))
                            }, null, 40, _hoisted_87),
                            _hoisted_88,
                            _hoisted_89
                          ])
                        ], 64))
                      : (_ctx.lessonUploadStatus === 'uploading' || _ctx.lessonUploadStatus === 'extracting')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                            _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.lessonUploadFile ? _ctx.lessonUploadFile.name : ''), 1),
                            _createElementVNode("div", _hoisted_92, [
                              (_ctx.lessonUploadStatus === 'uploading')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "upload-progress-bar",
                                    style: _normalizeStyle({ width: _ctx.lessonUploadProgress + '%' })
                                  }, null, 4))
                                : (_openBlock(), _createElementBlock("div", _hoisted_93))
                            ]),
                            _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.lessonUploadStatus === 'uploading' ? 'Wird hochgeladen … ' + _ctx.lessonUploadProgress + '%' : 'Wird entpackt …'), 1)
                          ]))
                        : (_ctx.lessonUploadStatus === 'success')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                              _hoisted_96,
                              _createElementVNode("span", null, _toDisplayString(_ctx.lessonIsVersionUpdate ? 'Entwurf bereit. Vorschau und Veröffentlichen in der Lektionsübersicht.' : 'Entpackt und gespeichert.'), 1)
                            ]))
                          : (_ctx.lessonUploadStatus === 'error')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                _hoisted_98,
                                _createElementVNode("span", null, _toDisplayString(_ctx.lessonUploadErrorMsg || 'Fehler beim Hochladen oder Entpacken.'), 1)
                              ]))
                            : _createCommentVNode("", true)
                  ]),
                  (_ctx.lessonSaveError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_99, _toDisplayString(_ctx.lessonSaveError), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.lessonModalVisible = false))
                    }, "Abbrechen"),
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      disabled: _ctx.lessonSaving || _ctx.lessonUploadLoading || !_ctx.lessonForm.title,
                      onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.saveLesson && _ctx.saveLesson(...args)))
                    }, _toDisplayString(_ctx.lessonSaving ? 'Wird gespeichert …' : (_ctx.lessonUploadLoading ? 'ZIP wird geladen …' : 'Speichern')), 9, _hoisted_101)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.deleteLessonTarget)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "modal-backdrop",
                onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.deleteLessonTarget = null), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_102, [
                  _hoisted_103,
                  _createElementVNode("p", _hoisted_104, [
                    _createTextVNode(" Möchten Sie die Lektion "),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.deleteLessonTarget.title), 1),
                    _createTextVNode(" wirklich löschen? ")
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.deleteLessonTarget = null))
                    }, "Abbrechen"),
                    _createElementVNode("button", {
                      class: "btn btn-danger",
                      disabled: _ctx.deletingLesson,
                      onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.doDeleteLesson && _ctx.doDeleteLesson(...args)))
                    }, _toDisplayString(_ctx.deletingLesson ? 'Wird gelöscht …' : 'Löschen'), 9, _hoisted_106)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.orgPickerVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "modal-backdrop",
                onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.orgPickerVisible = false), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _createElementVNode("button", {
                      class: "btn-close",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.orgPickerVisible = false))
                    }, "×")
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.orgSearch) = $event)),
                    type: "text",
                    class: "form-input",
                    placeholder: "Suchen …",
                    style: {"margin-bottom":"10px"}
                  }, null, 512), [
                    [_vModelText, _ctx.orgSearch]
                  ]),
                  (_ctx.orgPickerLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_110, "Wird geladen …"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_111, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPickerOrgs, (org) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: org.organisationId,
                            class: "org-picker-row"
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: _ctx.isOrgSelected(org.organisationId),
                              onChange: ($event: any) => (_ctx.toggleOrg(org))
                            }, null, 40, _hoisted_112),
                            _createElementVNode("span", _hoisted_113, _toDisplayString(org.name), 1),
                            _createElementVNode("span", _hoisted_114, _toDisplayString(org.organisationId), 1)
                          ]))
                        }), 128)),
                        (_ctx.filteredPickerOrgs.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_115, " Keine Organisationen gefunden. "))
                          : _createCommentVNode("", true)
                      ])),
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.orgPickerVisible = false))
                    }, "Fertig")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_117, [
        (_ctx.saveError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_ctx.saveError), 1))
          : _createCommentVNode("", true),
        (_ctx.saveSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_119, "Kurs gespeichert."))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_120, [
          _createVNode(_component_router_link, {
            to: "/superadmin/courses",
            class: "btn btn-secondary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Abbrechen")
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.saving,
            onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, _toDisplayString(_ctx.saving ? 'Wird gespeichert …' : (_ctx.isEdit ? 'Änderungen speichern' : 'Kurs anlegen')), 9, _hoisted_121)
        ])
      ])
    ]),
    (_ctx.scormPreview.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("div", _hoisted_124, [
              _hoisted_125,
              _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.scormPreview.title), 1),
              (_ctx.scormPreview.isDraft)
                ? (_openBlock(), _createElementBlock("span", _hoisted_127, "Entwurf"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_128, [
              _createElementVNode("span", {
                class: "scorm-preview-url",
                title: _ctx.scormPreview.url
              }, _toDisplayString(_ctx.scormPreview.url), 9, _hoisted_129),
              _createElementVNode("button", {
                class: "scorm-preview-close",
                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.closeScormPreview && _ctx.closeScormPreview(...args))),
                title: "Vorschau schließen"
              }, "✕ Schließen")
            ])
          ]),
          (_ctx.scormPreview.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                _hoisted_131,
                _createElementVNode("div", _hoisted_132, [
                  _hoisted_133,
                  _createElementVNode("p", null, [
                    _createTextVNode(" Die Datei wurde nicht gefunden unter:"),
                    _hoisted_134,
                    _createElementVNode("code", null, _toDisplayString(_ctx.scormPreview.url), 1)
                  ]),
                  _hoisted_135
                ])
              ]))
            : (_openBlock(), _createElementBlock("iframe", {
                key: 1,
                ref: "scormIframe",
                src: _ctx.scormPreview.url,
                class: "scorm-preview-iframe",
                allow: "autoplay; fullscreen",
                onLoad: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.onScormIframeLoad && _ctx.onScormIframeLoad(...args)))
              }, null, 40, _hoisted_136))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}